import BaseStore from '@/store/BaseStore'
import { Action, Module, Mutation } from '@/node_modules/vuex-module-decorators'
import {
  bibliographyApi,
  BibliographySearchRequest,
  BibliographySearchResultItem,
  BibliographySearchRequestToJSON,
  BibliographyAloneSearchRequest,
  BibliographyAloneSearchRequestToJSON,
  BibliographyFreeSearchRequest,
  BibliographyFreeSearchRequestToJSON,
  BibliographySearchResultAuthorityItem,
  BibliographySearchResultContentItem,
  BibliographySearchTooliRequest,
  BibliographyAloneSearchTooliRequest,
  BibliographySearchResult,
  BibliographySearchNarrowCondition,
  defaultBibliographySearchNarrowCondition
} from '@/api'

// TODO @/apiからimportだとundefinedとなる by nagasu
import {
  BibliographySearchListDetail,
  BibliographySearchListDetailRequest
} from '@/api/models/bibliography'

import { InputAloneSearchItem } from '@/components/organisms/BibliographyAloneSearch'
import { InputBasicSearchBibliographyItem } from '@/components/organisms/BibliographyBasicSearchBibliography'
import { InputBasicSearchCollectionItem } from '@/components/organisms/BibliographyBasicSearchCollection'
import {
  defaultInputSearchOptionItem,
  InputSearchOptionItem
} from '@/components/organisms/BibliographySearchOption'
import {
  defaultSearchCondition,
  SearchCondition
} from '@/pages/bibliographies/index.vue'
import {
  defaultInputBibliographySearchResultsOption,
  InputBibliographySearchResultsOption
} from '@/components/organisms/BibliographySearchResultsOption/BibliographySearchResultsOption.vue'
import {
  AloneSearchType,
  AuthoritySearchType,
  BibliographySearchSortKey,
  BibliographySearchSortOrder,
  BibliographySearchType,
  CollectionStatus,
  DisplayMethod,
  NarrowTarget,
  Prefix,
  SearchTarget
} from '@/types'
import { toHalfWidth } from '@/utils'
import { bibliographyDetailStore } from '@/utils/store-accessor'

type ListDetailFetchItem = {
  startIndex: number
  endIndex: number
  items: BibliographySearchListDetail[]
}

const PER_FETCH_COUNT = 100
// 全件取得する都合、取得数が多くなる傾向がある為、桁を増やして対応
const PER_FETCH_ALL_COUNT = 1000

const SEARCH_ALL_NUMBER_OF_LIMIT = 9999

@Module({
  name: 'BibliographySearchStore',
  namespaced: true,
  stateFactory: true
})
export default class BibliographySearchStore extends BaseStore {
  _searchCondition: SearchCondition = defaultSearchCondition()

  _bibliographySearchType: BibliographySearchType = BibliographySearchType.Basic

  _page: number = 1

  _total: number = 0

  _items: BibliographySearchResultItem[] = []

  _displayOption: InputBibliographySearchResultsOption = defaultInputBibliographySearchResultsOption()

  _authoritySearchType: AuthoritySearchType = AuthoritySearchType.Author

  _authorityItems: BibliographySearchResultAuthorityItem[] = []

  _contentItems: BibliographySearchResultContentItem[] = []

  _authorIds: string[] = []

  _subjectIds: string[] = []

  _seriesIds: string[] = []

  _completeWorksIds: string[] = []

  _contentAuthorIds: string[] = []

  _publisherIds: string[] = []

  _sortKey: BibliographySearchSortKey = ''

  _sortOrder: BibliographySearchSortOrder = ''

  // 検索履歴保存が通常処理とする
  _saveHistory: boolean = true

  _selectedUids: string[] = []

  _scrollTopValue: number = 0

  _authorityScrollTopValue: number = 0

  _activeRowIndex: number = -1

  _authorityActiveRowIndex: number = -1

  _isAllSelect: boolean = false

  _searchBasicCollectionId: boolean = false

  _isFetchingBibliographySearchList: boolean = false

  // あくまで絞り「こんだ」条件の為、扱いには注意を払うように
  _narrowedCondition: BibliographySearchNarrowCondition = defaultBibliographySearchNarrowCondition()

  get bibliographySearchType() {
    return this._bibliographySearchType
  }

  get page() {
    return this._page
  }

  get perPage() {
    return this._searchCondition.searchOption.numberOfLimit.input
  }

  get total() {
    return this._total
  }

  get items(): BibliographySearchResultItem[] {
    return this._items
  }

  get filterItems(): BibliographySearchResultItem[] {
    let results: BibliographySearchResultItem[] = this._items

    if (this._displayOption.selectedOnly.input) {
      results = results.filter(item => this._selectedUids.includes(item.uid))
    }
    if (this._displayOption.canLendOnly.input) {
      results = results.filter(item => item.collectionStatus === '書架')
    }

    return results
  }

  get authoritySearchType() {
    return this._authoritySearchType
  }

  get authorityItems() {
    return this._authorityItems
  }

  get contentItems() {
    return this._contentItems
  }

  get inputSearchOption() {
    return this._searchCondition.searchOption
  }

  get inputBasicSearchBibliographyItem() {
    return this._searchCondition.basic.bibliography
  }

  get inputBasicSearchCollectionItem() {
    return this._searchCondition.basic.collection
  }

  get inputAloneSearchItem() {
    return this._searchCondition.alone
  }

  get freeWords() {
    return this._searchCondition.free
  }

  get inputAuthoritySearchItem() {
    return this._searchCondition.authority
  }

  get inputContentSearchItem() {
    return this._searchCondition.content
  }

  get displayOption() {
    return this._displayOption
  }

  get displayMethod() {
    return this._searchCondition.searchOption.displayMethod.input
  }

  get searchTarget() {
    return this._searchCondition.searchOption.searchTarget.input
  }

  get sortKey() {
    return this._sortKey
  }

  get sortOrder() {
    return this._sortOrder
  }

  get saveHistory(): boolean {
    return this._saveHistory
  }

  get selectedUids(): string[] {
    return this._selectedUids
  }

  get scrollTopValue(): number {
    return this._scrollTopValue
  }

  get authorityScrollTopValue(): number {
    return this._authorityScrollTopValue
  }

  get activeRowIndex(): number {
    return this._activeRowIndex
  }

  get authorityActiveRowIndex(): number {
    return this._authorityActiveRowIndex
  }

  get isAllSelect(): boolean {
    return this._isAllSelect
  }

  get searchBasicCollectionId(): boolean {
    return this._searchBasicCollectionId
  }

  get isFetchingBibliographySearchList(): boolean {
    return this._isFetchingBibliographySearchList
  }

  get narrowedSearchCondition(): BibliographySearchNarrowCondition {
    return this._narrowedCondition
  }

  get basicSearchBaseRequest(): BibliographySearchRequest {
    return {
      displayMethod: this.inputSearchOption.displayMethod.input,
      searchTarget: this.inputSearchOption.searchTarget.input,
      numberOfLimit: this.inputSearchOption.numberOfLimit.input,
      searchMethodAnd: this.inputSearchOption.searchMethodAnd.input,
      searchMethodSynonym: this.inputSearchOption.searchMethodSynonym.input,
      searchMethodAllograph: this.inputSearchOption.searchMethodAllograph.input,
      andSearchType: this.inputSearchOption.andSearchType,
      andCollectionTarget: this.inputSearchOption.andCollectionTarget,
      andMaterialFormat: this.inputSearchOption.andMaterialFormat.input
        .split(',')
        .filter(
          (value, index, array) =>
            value !== '' && array.indexOf(value) === index
        ),
      andBibliographyClass: this.inputSearchOption.andBibliographyClass,
      displayBranchCode: this._displayOption.displayBranchCode.input,
      bibliography: {
        title1: this.inputBasicSearchBibliographyItem.title1.input,
        title1Not: this.inputBasicSearchBibliographyItem.title1.not,
        title2: this.inputBasicSearchBibliographyItem.title2.input,
        title2Not: this.inputBasicSearchBibliographyItem.title2.not,
        titleInformation: this.inputBasicSearchBibliographyItem
          .titleInformation,
        author1: this.inputBasicSearchBibliographyItem.author1.input,
        author1No: this.inputBasicSearchBibliographyItem.author1.no,
        author1Not: this.inputBasicSearchBibliographyItem.author1.not,
        author2: this.inputBasicSearchBibliographyItem.author2.input,
        author2No: this.inputBasicSearchBibliographyItem.author2.no,
        author2Not: this.inputBasicSearchBibliographyItem.author2.not,
        authorInformation: this.inputBasicSearchBibliographyItem
          .authorInformation,
        authorNos: this.inputBasicSearchBibliographyItem.authorIds.ids,
        subject1: this.inputBasicSearchBibliographyItem.subject1.input,
        subject1No: this.inputBasicSearchBibliographyItem.subject1.no,
        subject1Not: this.inputBasicSearchBibliographyItem.subject1.not,
        subject2: this.inputBasicSearchBibliographyItem.subject2.input,
        subject2No: this.inputBasicSearchBibliographyItem.subject2.no,
        subject2Not: this.inputBasicSearchBibliographyItem.subject2.not,
        subjectNos: this.inputBasicSearchBibliographyItem.subjectIds.ids,
        series: this.inputBasicSearchBibliographyItem.series.input,
        seriesNo: this.inputBasicSearchBibliographyItem.series.no,
        seriesNot: this.inputBasicSearchBibliographyItem.series.not,
        seriesNos: this.inputBasicSearchBibliographyItem.seriesIds.ids,
        completeWorks: this.inputBasicSearchBibliographyItem.completeWorks
          .input,
        completeWorksNo: this.inputBasicSearchBibliographyItem.completeWorks.no,
        completeWorksNot: this.inputBasicSearchBibliographyItem.completeWorks
          .not,
        completeWorksNos: this.inputBasicSearchBibliographyItem.completeWorksIds
          .ids,
        note: this.inputBasicSearchBibliographyItem.note.input,
        publisher: this.inputBasicSearchBibliographyItem.publisher.input,
        publisherNo: this.inputBasicSearchBibliographyItem.publisher.no,
        publisherNot: this.inputBasicSearchBibliographyItem.publisher.not,
        publisherNos: this.inputBasicSearchBibliographyItem.publisherIds.ids,
        volumeLabel: this.inputBasicSearchBibliographyItem.volumeLabel.input,
        volumeLabelNot: this.inputBasicSearchBibliographyItem.volumeLabel.not,
        classNo: this.inputBasicSearchBibliographyItem.classNo.input,
        publishedYearFrom: this.inputBasicSearchBibliographyItem
          .publishedYearFrom.input,
        publishedYearTo: this.inputBasicSearchBibliographyItem.publishedYearTo
          .input,
        playbackTimeFrom: this.inputBasicSearchBibliographyItem.playbackTimeFrom
          .input,
        playbackTimeTo: this.inputBasicSearchBibliographyItem.playbackTimeTo
          .input,
        volume: this.inputBasicSearchBibliographyItem.volume.input,
        volumeNumber: this.inputBasicSearchBibliographyItem.volumeNumber.input,
        volumeTotal: this.inputBasicSearchBibliographyItem.volumeTotal.input,
        dateLabel: this.inputBasicSearchBibliographyItem.dateLabel.input,
        genres: this.inputBasicSearchBibliographyItem.genres.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        targetUsers: this.inputBasicSearchBibliographyItem.targetUsers.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        targetUsersAv: this.inputBasicSearchBibliographyItem.targetUsersAv.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          )
      },
      collection: {
        collectionTypes: this.inputBasicSearchCollectionItem.collectionTypes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        shelfTypes: this.inputBasicSearchCollectionItem.shelfTypes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        callNumberMark: this.inputBasicSearchCollectionItem.callNumberMark
          .input,
        callNumberNdc: this.inputBasicSearchCollectionItem.callNumberNdc.input,
        callNumberBook: this.inputBasicSearchCollectionItem.callNumberBook
          .input,
        callNumberSub: this.inputBasicSearchCollectionItem.callNumberSub.input,
        traderCodes: this.inputBasicSearchCollectionItem.traderCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        donorCodes: this.inputBasicSearchCollectionItem.donorCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        collectionStatus: this.inputBasicSearchCollectionItem.collectionStatus.input
          .split(',')
          .filter((value, index, array) => {
            if (
              this.inputBasicSearchCollectionItem.collectionStatus
                .collectionStatusRemove
            ) {
              return value !== '' && array.indexOf(value) === index
            }

            return (
              value !== CollectionStatus.Removed &&
              value !== '' &&
              array.indexOf(value) === index
            )
          }),
        collectionStatusRemove: this.inputBasicSearchCollectionItem
          .collectionStatus.collectionStatusRemove,
        holdingBranchCodes: this.inputBasicSearchCollectionItem.holdingBranchCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        orderStatus: this.inputBasicSearchCollectionItem.orderStatus.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        orderBranchCodes: this.inputBasicSearchCollectionItem.orderBranchCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        acceptDateFrom: this.inputBasicSearchCollectionItem.acceptDateFrom
          .input,
        acceptDateTo: this.inputBasicSearchCollectionItem.acceptDateTo.input,
        handlingTypes: this.inputBasicSearchCollectionItem.handlingTypes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        lendTotal: this.inputBasicSearchCollectionItem.lendTotal.input,
        lendTotalFlag: this.inputBasicSearchCollectionItem.lendTotalFlag.input,
        lastLendDate: this.inputBasicSearchCollectionItem.lastLendDate.input,
        lastLendDateFlag: this.inputBasicSearchCollectionItem.lastLendDateFlag
          .input
      },
      narrow: this.narrowedSearchCondition,
      sortKey: this.sortKey,
      sortOrder: this.sortOrder,
      page: this.page,
      _saveHistory: this.saveHistory
    }
  }

  get aloneSearchBaseRequest(): BibliographyAloneSearchRequest {
    if (this.searchBasicCollectionId) {
      return {
        displayMethod: this.inputSearchOption.displayMethod.input,
        searchTarget: this.inputSearchOption.searchTarget.input,
        numberOfLimit: this.inputSearchOption.numberOfLimit.input,
        newPublicationInformationDate: undefined,
        newPublicationInformationVolume: undefined,
        collectionNo: toHalfWidth(
          this.inputBasicSearchBibliographyItem.title1.input
        ),
        exceptCheckDigit: false,
        orderId: undefined,
        bibliographyClass: undefined,
        bibliographyId: undefined,
        isbn: undefined,
        productNumber: undefined,
        magazineCode: undefined,
        marcType: undefined,
        marcNo: undefined,
        sortKey: this.sortKey,
        sortOrder: this.sortOrder,
        _saveHistory: this.saveHistory,
        narrow: this.narrowedSearchCondition
      }
    } else {
      return {
        displayMethod: this.inputSearchOption.displayMethod.input,
        searchTarget: this.inputSearchOption.searchTarget.input,
        numberOfLimit: this.inputSearchOption.numberOfLimit.input,
        newPublicationInformationDate:
          this.inputAloneSearchItem.searchType ===
          AloneSearchType.NewPublicationInformationDate
            ? this.inputAloneSearchItem.newPublicationInformationDate.input
            : undefined,
        newPublicationInformationVolume:
          this.inputAloneSearchItem.searchType ===
          AloneSearchType.NewPublicationInformationVolume
            ? this.inputAloneSearchItem.newPublicationInformationVolume.input
            : undefined,
        collectionNo:
          this.inputAloneSearchItem.searchType === AloneSearchType.CollectionNo
            ? this.inputAloneSearchItem.collectionNo.input
            : undefined,
        exceptCheckDigit:
          this.inputAloneSearchItem.searchType === AloneSearchType.CollectionNo
            ? this.inputAloneSearchItem.collectionNo.exceptCheckDigit
            : undefined,
        orderId:
          this.inputAloneSearchItem.searchType === AloneSearchType.OrderId
            ? this.inputAloneSearchItem.orderId.input
            : undefined,
        bibliographyClass:
          this.inputAloneSearchItem.searchType === AloneSearchType.Bibliography
            ? this.inputAloneSearchItem.bibliographyId.bibliographyClass ?? ''
            : undefined,
        bibliographyId:
          this.inputAloneSearchItem.searchType === AloneSearchType.Bibliography
            ? this.inputAloneSearchItem.bibliographyId.input
            : undefined,
        isbn:
          this.inputAloneSearchItem.searchType === AloneSearchType.Isbn
            ? this.inputAloneSearchItem.isbn.input
            : undefined,
        productNumber:
          this.inputAloneSearchItem.searchType === AloneSearchType.ProductNumber
            ? this.inputAloneSearchItem.productNumber.input
            : undefined,
        magazineCode:
          this.inputAloneSearchItem.searchType === AloneSearchType.MagazineCode
            ? this.inputAloneSearchItem.magazineCode.input
            : undefined,
        marcType:
          this.inputAloneSearchItem.searchType === AloneSearchType.Marc
            ? this.inputAloneSearchItem.marcType.input
            : undefined,
        marcNo:
          this.inputAloneSearchItem.searchType === AloneSearchType.Marc
            ? this.inputAloneSearchItem.marcNo.input
            : undefined,
        sortKey: this.sortKey,
        sortOrder: this.sortOrder,
        _saveHistory: this.saveHistory,
        narrow: this.narrowedSearchCondition
      }
    }
  }

  get freeSearchBaseRequest(): BibliographyFreeSearchRequest {
    return {
      displayMethod: this.inputSearchOption.displayMethod.input,
      searchTarget: this.inputSearchOption.searchTarget.input,
      numberOfLimit: this.inputSearchOption.numberOfLimit.input,
      searchMethodAnd: true,
      searchMethodSynonym: this.inputSearchOption.searchMethodSynonym.input,
      searchMethodAllograph: this.inputSearchOption.searchMethodAllograph.input,
      andSearchType: this.inputSearchOption.andSearchType,
      andCollectionTarget: this.inputSearchOption.andCollectionTarget,
      andMaterialFormat: this.inputSearchOption.andMaterialFormat.input
        .split(',')
        .filter(
          (value, index, array) =>
            value !== '' && array.indexOf(value) === index
        ),
      andBibliographyClass: this.inputSearchOption.andBibliographyClass,
      displayBranchCode: '',
      freeWords: this.freeWords.freeWords.input,
      bibliography: {
        classNo: this.freeWords.andKey.classNo.input
      },
      collection: {
        collectionTypes: this.freeWords.andKey.collectionTypes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        shelfTypes: this.freeWords.andKey.shelfTypes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        callNumberMark: this.freeWords.andKey.callNumberMark.input,
        callNumberNdc: this.freeWords.andKey.callNumberNdc.input,
        callNumberBook: this.freeWords.andKey.callNumberBook.input,
        callNumberSub: this.freeWords.andKey.callNumberSub.input,
        traderCodes: this.freeWords.andKey.traderCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        donorCodes: this.freeWords.andKey.donorCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        collectionStatus: this.freeWords.andKey.collectionStatus.input
          .split(',')
          .filter((value, index, array) => {
            if (this.freeWords.andKey.collectionStatus.collectionStatusRemove) {
              return value !== '' && array.indexOf(value) === index
            }

            return (
              value !== CollectionStatus.Removed &&
              value !== '' &&
              array.indexOf(value) === index
            )
          }),
        collectionStatusRemove: this.freeWords.andKey.collectionStatus
          .collectionStatusRemove,
        holdingBranchCodes: this.freeWords.andKey.holdingBranchCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        orderStatus: this.freeWords.andKey.orderStatus.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        orderBranchCodes: this.freeWords.andKey.orderBranchCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        acceptDateFrom: this.freeWords.andKey.acceptDateFrom.input,
        acceptDateTo: this.freeWords.andKey.acceptDateTo.input,
        handlingTypes: this.freeWords.andKey.handlingTypes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          ),
        lendTotal: this.freeWords.andKey.lendTotal.input,
        lendTotalFlag: this.freeWords.andKey.lendTotalFlag.input,
        lastLendDate: this.freeWords.andKey.lastLendDate.input,
        lastLendDateFlag: this.freeWords.andKey.lastLendDateFlag.input
      },
      narrow: this.narrowedSearchCondition,
      sortKey: this.sortKey,
      sortOrder: this.sortOrder,
      page: this.page,
      _saveHistory: this.saveHistory
    }
  }

  get authorityIdSearchBaseRequest(): BibliographySearchRequest {
    const defaultSearchOptionItem: InputSearchOptionItem = defaultInputSearchOptionItem()
    return {
      displayMethod: defaultSearchOptionItem.displayMethod.input,
      searchTarget: defaultSearchOptionItem.searchTarget.input,
      numberOfLimit: defaultSearchOptionItem.numberOfLimit.input,
      searchMethodAnd: defaultSearchOptionItem.searchMethodAnd.input,
      searchMethodSynonym: defaultSearchOptionItem.searchMethodSynonym.input,
      searchMethodAllograph:
        defaultSearchOptionItem.searchMethodAllograph.input,
      andSearchType: defaultSearchOptionItem.andSearchType,
      andCollectionTarget: defaultSearchOptionItem.andCollectionTarget,
      andMaterialFormat: defaultSearchOptionItem.andMaterialFormat.input
        .split(',')
        .filter(
          (value, index, array) =>
            value !== '' && array.indexOf(value) === index
        ),
      andBibliographyClass: defaultSearchOptionItem.andBibliographyClass,
      displayBranchCode: this._displayOption.displayBranchCode.input,
      bibliography: {
        title1: '',
        title1Not: false,
        title2: '',
        title2Not: false,
        titleInformation: false,
        author1: '',
        author1No: '',
        author1Not: false,
        author2: '',
        author2No: '',
        author2Not: false,
        authorInformation: false,
        authorNos: this._authorIds,
        subject1: '',
        subject1No: '',
        subject1Not: false,
        subject2: '',
        subject2No: '',
        subject2Not: false,
        subjectNos: this._subjectIds,
        series: '',
        seriesNo: '',
        seriesNot: false,
        seriesNos: this._seriesIds,
        completeWorks: '',
        completeWorksNo: '',
        completeWorksNot: false,
        completeWorksNos: this._completeWorksIds,
        note: '',
        publisher: '',
        publisherNo: '',
        publisherNot: false,
        publisherNos: this._publisherIds,
        volumeLabel: '',
        volumeLabelNot: false,
        classNo: '',
        publishedYearFrom: '',
        publishedYearTo: '',
        playbackTimeFrom: '',
        playbackTimeTo: '',
        volume: '',
        volumeNumber: '',
        volumeTotal: '',
        dateLabel: '',
        genres: [],
        targetUsers: [],
        targetUsersAv: []
      },
      collection: {
        collectionTypes: [],
        shelfTypes: [],
        callNumberMark: '',
        callNumberNdc: '',
        callNumberBook: '',
        callNumberSub: '',
        traderCodes: [],
        donorCodes: [],
        collectionStatus: [],
        collectionStatusRemove: true,
        holdingBranchCodes: [],
        orderStatus: [],
        orderBranchCodes: [],
        acceptDateFrom: '',
        acceptDateTo: '',
        handlingTypes: [],
        lendTotal: '',
        lendTotalFlag: '',
        lastLendDate: '',
        lastLendDateFlag: ''
      },
      narrow: this.narrowedSearchCondition,
      sortKey: this.sortKey,
      sortOrder: this.sortOrder,
      page: this.page,
      _saveHistory: false
    }
  }

  @Mutation
  public addPage() {
    this._page++
  }

  @Mutation
  public setPage(value: number) {
    this._page = value
  }

  @Mutation
  public resetPage() {
    this._page = 1
  }

  @Mutation
  public setTotal(value: number) {
    this._total = value
  }

  @Mutation
  public setItems(items: BibliographySearchResultItem[]) {
    this._items = items
  }

  @Mutation
  public addItems(items: BibliographySearchResultItem[]) {
    this._items.push(...items)
  }

  @Mutation
  public setAuthorityItems(items: BibliographySearchResultAuthorityItem[]) {
    this._authorityItems = items
  }

  @Mutation
  public setContentItems(items: BibliographySearchResultContentItem[]) {
    this._contentItems = items
  }

  @Mutation
  public setItemByListDetail(listDetailFetchItem: ListDetailFetchItem) {
    const newItems: BibliographySearchResultItem[] = []

    for (
      let i = listDetailFetchItem.startIndex;
      i < listDetailFetchItem.endIndex;
      i++
    ) {
      if (this._items.length === 0) return

      const oldItem = { ...this._items[i] }
      if (oldItem.prefix !== Prefix.Real || oldItem._fetched) {
        newItems.push(oldItem)
        continue
      }

      const newItem = listDetailFetchItem.items.find(item => {
        if (oldItem.bibliographyId > 0) {
          return item.id === oldItem.prefix + oldItem.bibliographyId
        }
        return item.marcNo === oldItem.marcNo
      })
      if (newItem === undefined) {
        newItems.push(oldItem)
        continue
      }

      oldItem.displayMaterialFormat = newItem.displayMaterialFormatName
      oldItem.collectionFlag = newItem.collectionFlag
      oldItem.collectionNo = newItem.collectionNo
      oldItem.shelfType = newItem.shelfType
      oldItem.callNo = newItem.callNo
      oldItem.handlingType = newItem.handlingType
      oldItem.canLendHandlingType = newItem.canLendHandlingType
      oldItem.collectionStatus = newItem.collectionStatus
      oldItem.shelfCount = String(newItem.shelfCount)
      oldItem.holdingCount = String(newItem.holdingCount)
      oldItem.orderCount = String(newItem.orderCount)
      oldItem.reserveCount = String(newItem.reserveCount)
      oldItem._fetched = true
      newItems.push(oldItem)
    }

    this._items.splice(
      listDetailFetchItem.startIndex,
      listDetailFetchItem.endIndex - listDetailFetchItem.startIndex,
      ...newItems
    )
  }

  @Mutation
  public resetListDetail() {
    const newItems = [...this._items]
    for (let i = 0; i < newItems.length; i++) {
      newItems[i]._fetched = false
    }
    this._items = newItems
  }

  @Mutation
  public setInputSearchOption(item: InputSearchOptionItem) {
    this._searchCondition.searchOption = item
  }

  @Mutation
  public setInputBasicSearchBibliographyItem(
    item: InputBasicSearchBibliographyItem
  ) {
    this._searchCondition.basic.bibliography = item
  }

  @Mutation
  public setInputBasicSearchCollectionItem(
    item: InputBasicSearchCollectionItem
  ) {
    this._searchCondition.basic.collection = item
  }

  @Mutation
  public setInputAloneSearchItem(item: InputAloneSearchItem) {
    this._searchCondition.alone = item
  }

  @Mutation
  public setDisplayOption(value: InputBibliographySearchResultsOption) {
    this._displayOption = value
  }

  @Mutation
  public setBibliographySearchType(value: BibliographySearchType) {
    this._bibliographySearchType = value
  }

  @Mutation
  public setSearchCondition(value: SearchCondition) {
    this._searchCondition = value
    this._displayOption.displayMethod = value.searchOption.displayMethod
  }

  @Mutation
  public setSearchDisplayMethod(value: DisplayMethod) {
    this._searchCondition.searchOption.displayMethod.input = value
  }

  @Mutation
  public setAuthoritySearchType(value: AuthoritySearchType) {
    this._authoritySearchType = value
  }

  @Mutation
  public setAuthorIds(ids: string[]) {
    this._authorIds = ids
  }

  @Mutation
  public setSubjectIds(ids: string[]) {
    this._subjectIds = ids
  }

  @Mutation
  public setSeriesIds(ids: string[]) {
    this._seriesIds = ids
  }

  @Mutation
  public setCompleteWorksIds(ids: string[]) {
    this._completeWorksIds = ids
  }

  @Mutation
  public setContentAuthorIds(ids: string[]) {
    this._contentAuthorIds = ids
  }

  @Mutation
  public setPublisherIds(ids: string[]) {
    this._publisherIds = ids
  }

  @Mutation
  public setSortKey(value: BibliographySearchSortKey) {
    this._sortKey = value
  }

  @Mutation
  public setSortOrder(value: BibliographySearchSortOrder) {
    this._sortOrder = value
  }

  @Mutation
  public setSaveHistory(value: boolean) {
    this._saveHistory = value
  }

  @Mutation
  public setSelectedUids(value: string[]) {
    this._selectedUids = value
  }

  @Mutation
  public setScrollTopValue(value: number) {
    this._scrollTopValue = value
  }

  @Mutation
  public setAuthorityScrollTopValue(value: number) {
    this._authorityScrollTopValue = value
  }

  @Mutation
  public setActiveRowIndex(value: number) {
    this._activeRowIndex = value
  }

  @Mutation
  public setAuthorityActiveRowIndex(value: number) {
    this._authorityActiveRowIndex = value
  }

  @Mutation
  public setIsAllSelect(value: boolean) {
    this._isAllSelect = value
  }

  @Mutation
  public setSearchBasicCollectionId(value: boolean) {
    this._searchBasicCollectionId = value
  }

  @Mutation
  public setIsFetchingBibliographySearchList(value: boolean) {
    this._isFetchingBibliographySearchList = value
  }

  @Mutation
  public setNarrowedCondition(value: BibliographySearchNarrowCondition) {
    this._narrowedCondition = value
  }

  @Mutation
  public reset() {
    this._page = 1
    this._total = 0
    this._items = []
    this._authorityItems = []
    this._contentItems = []
    this._displayOption = defaultInputBibliographySearchResultsOption()
    this._authorIds = []
    this._subjectIds = []
    this._seriesIds = []
    this._completeWorksIds = []
    this._contentAuthorIds = []
    this._publisherIds = []
    this._sortKey = ''
    this._sortOrder = ''
    this._saveHistory = true
    this._selectedUids = []
    this._scrollTopValue = 0
    this._authorityScrollTopValue = 0
    this._activeRowIndex = -1
    this._authorityActiveRowIndex = -1
    this._isAllSelect = false
    this._searchBasicCollectionId = false
    this._isFetchingBibliographySearchList = false
    this._narrowedCondition = defaultBibliographySearchNarrowCondition()
  }

  @Action({ rawError: true })
  public async search() {
    if (this.inputSearchOption.searchTarget.input === SearchTarget.Tooli) {
      await this.basicSearchTooli()
    } else {
      await this.basicSearch()
    }
  }

  @Action({ rawError: true })
  public async searchAll(isReconfigure: boolean = false): Promise<void> {
    this.setSaveHistory(false)

    switch (this.bibliographySearchType) {
      case BibliographySearchType.Basic:
        if (
          this._searchCondition.searchOption.searchTarget.input !==
          SearchTarget.Tooli
        ) {
          await this.basicSearchAll(isReconfigure)
        }
        break
      case BibliographySearchType.Alone:
        if (
          this._searchCondition.searchOption.searchTarget.input !==
          SearchTarget.Tooli
        ) {
          await this.aloneSearch(this.searchBasicCollectionId)
        }
        break
      case BibliographySearchType.Free:
        await this.freeSearchAll(isReconfigure)
        break
      case BibliographySearchType.Authority:
        await this.authorityIdSearchAll(isReconfigure)
        break
      default:
        return
    }

    await this.fetchSearchListDetailAll()

    if (isReconfigure) {
      return
    }

    // pageを最大値まで設定
    this.setPage(
      Math.floor(this.total / this.inputSearchOption.numberOfLimit.input) +
        (this.total % this.inputSearchOption.numberOfLimit.input > 0 ? 1 : 0)
    )
  }

  @Action({ rawError: true })
  public async basicSearch(signal?: AbortSignal) {
    this.setBibliographySearchType('basic')

    const result = await bibliographyApi.getBibliographies(
      BibliographySearchRequestToJSON(this.basicSearchBaseRequest),
      signal
    )

    if (this.page === 1) {
      this.setTotal(result.total)
      this.setItems(result.items)
    } else {
      this.addItems(result.items)
    }

    this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async basicSearchTooli(signal?: AbortSignal) {
    this.setBibliographySearchType('basic')

    const request: BibliographySearchTooliRequest = {
      displayMethod: this.inputSearchOption.displayMethod.input,
      searchMethodAnd: this.inputSearchOption.searchMethodAnd.input,
      displayBranchCode: this._displayOption.displayBranchCode.input,
      title1: this.inputBasicSearchBibliographyItem.title1.input,
      title1Not: this.inputBasicSearchBibliographyItem.title1.not,
      title2: this.inputBasicSearchBibliographyItem.title2.input,
      title2Not: this.inputBasicSearchBibliographyItem.title2.not,
      author1: this.inputBasicSearchBibliographyItem.author1.input,
      author1Not: this.inputBasicSearchBibliographyItem.author1.not,
      author2: this.inputBasicSearchBibliographyItem.author2.input,
      author2Not: this.inputBasicSearchBibliographyItem.author2.not,
      subject1: this.inputBasicSearchBibliographyItem.subject1.input,
      subject1Not: this.inputBasicSearchBibliographyItem.subject1.not,
      subject2: this.inputBasicSearchBibliographyItem.subject2.input,
      subject2Not: this.inputBasicSearchBibliographyItem.subject2.not,
      series: this.inputBasicSearchBibliographyItem.series.input,
      seriesNot: this.inputBasicSearchBibliographyItem.series.not,
      publisher: this.inputBasicSearchBibliographyItem.publisher.input,
      publisherNot: this.inputBasicSearchBibliographyItem.publisher.not,
      classNo: this.inputBasicSearchBibliographyItem.classNo.input,
      publishedYearFrom: this.inputBasicSearchBibliographyItem.publishedYearFrom
        .input,
      publishedYearTo: this.inputBasicSearchBibliographyItem.publishedYearTo
        .input,
      freeWord: this.inputBasicSearchBibliographyItem.freeWord.input
    }

    const result = await bibliographyApi.searchTooliBibliographies(
      request,
      signal
    )

    if (this.page === 1) {
      this.setTotal(result.total)
      this.setItems(result.items)
    } else {
      this.addItems(result.items)
    }

    this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async aloneSearch(isInputBasicSearch: boolean, signal?: AbortSignal) {
    this.setBibliographySearchType('alone')

    this.setSearchBasicCollectionId(isInputBasicSearch)

    if (isInputBasicSearch) {
      bibliographyDetailStore.setInitialSelectCollectionNo(
        toHalfWidth(this.inputBasicSearchBibliographyItem.title1.input)
      )
    } else if (
      this.inputAloneSearchItem.searchType === AloneSearchType.CollectionNo
    ) {
      bibliographyDetailStore.setInitialSelectCollectionNo(
        this.inputAloneSearchItem.collectionNo.input
      )
    }

    const result = await bibliographyApi.getAloneBibliographies(
      BibliographyAloneSearchRequestToJSON(this.aloneSearchBaseRequest),
      signal
    )
    this.setTotal(result.total)
    this.setItems(result.items)

    this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async aloneSearchTooli(signal?: AbortSignal) {
    this.setBibliographySearchType('alone')

    const request: BibliographyAloneSearchTooliRequest = {
      displayMethod: this.inputSearchOption.displayMethod.input,
      newPublicationInformationVolume:
        this.inputAloneSearchItem.searchType ===
        AloneSearchType.NewPublicationInformationVolume
          ? this.inputAloneSearchItem.newPublicationInformationVolume.input
          : undefined,
      isbn:
        this.inputAloneSearchItem.searchType === AloneSearchType.Isbn
          ? this.inputAloneSearchItem.isbn.input
          : undefined,
      marcType:
        this.inputAloneSearchItem.searchType === AloneSearchType.Marc
          ? this.inputAloneSearchItem.marcType.input
          : undefined,
      marcNo:
        this.inputAloneSearchItem.searchType === AloneSearchType.Marc
          ? this.inputAloneSearchItem.marcNo.input
          : undefined
    }

    const result = await bibliographyApi.searchAloneTooliBibliographies(
      request,
      signal
    )
    this.setTotal(result.total)
    this.setItems(result.items)

    this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async freeSearch(signal?: AbortSignal) {
    this.setBibliographySearchType('free')

    const result = await bibliographyApi.getFreeBibliographies(
      BibliographyFreeSearchRequestToJSON(this.freeSearchBaseRequest),
      signal
    )

    if (this.page === 1) {
      this.setTotal(result.total)
      this.setItems(result.items)
    } else {
      this.addItems(result.items)
    }

    this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async fetchSearchListDetail(all: boolean = false) {
    if (this._items.length === 0) return

    this.setIsFetchingBibliographySearchList(true)

    // 繰り返し途中で検索結果が書き換わる可能性がある為、参照を変数に格納して処理する
    const tempReference: BibliographySearchResultItem[] = this._items
    // 繰り返し途中で参照を変えずに値が追加される可能性がある為、この時点でのページ数を格納する
    const tempPage: number = this._page

    let startIndex = 0
    if (!all) {
      startIndex =
        (this.page - 1) * this._searchCondition.searchOption.numberOfLimit.input
    }

    const loopCount = Math.ceil(
      (tempReference.length - startIndex) / PER_FETCH_COUNT
    )

    let start: number = startIndex
    let end: number = startIndex + PER_FETCH_COUNT
    for (let i = 1; i <= loopCount; i++) {
      if (this._items !== tempReference) {
        // 状況的に強制終了させるタイミングは、検索結果が更新され新しい検索リストを取得している状況の時なので、新規検索結果が存在しない場合、処理中真偽値フラグは更新しないままとする
        if (this._items.length === 0) {
          this.setIsFetchingBibliographySearchList(false)
        }
        return
      }

      if (end > tempReference.length) {
        end = tempReference.length
      }

      const bibliographies = tempReference
        .slice(start, end)
        .filter(item => item.prefix === Prefix.Real && !item._fetched)
        .map(item => {
          let id
          let marcNo
          if (item.bibliographyId > 0) {
            id = item.bibliographyId
            marcNo = undefined
          } else {
            id = undefined
            marcNo = item.marcNo
          }
          return {
            prefix: item.prefix,
            id,
            marcNo
          }
        })

      if (bibliographies.length > 0) {
        const request: BibliographySearchListDetailRequest = {
          bibliographies,
          displayBranchCode: this._displayOption.displayBranchCode.input
        }

        const items = await bibliographyApi.getBibliographySearchListDetail(
          request
        )
        this.setItemByListDetail({
          startIndex: start,
          endIndex: end,
          items
        })
      }

      start += PER_FETCH_COUNT
      end += PER_FETCH_COUNT
    }

    // 処理途中で検索結果の追加が行われなかったときのみ真偽値フラグを下げる
    if (this._page === tempPage) {
      this.setIsFetchingBibliographySearchList(false)
    }
  }

  @Action({ rawError: true })
  public async fetchSearchListDetailAll() {
    if (this._items.length === 0) return

    this.setIsFetchingBibliographySearchList(true)

    // 繰り返し途中で検索結果が書き換わる可能性がある為、参照を変数に格納して処理する
    const tempReference: BibliographySearchResultItem[] = this._items
    // 繰り返し途中で参照を変えずに値が追加される可能性がある為、この時点でのページ数を格納する
    const tempPage: number = this._page

    const startIndex = 0
    const loopCount = Math.ceil(tempReference.length / PER_FETCH_ALL_COUNT)
    const promiseArray: Promise<BibliographySearchListDetail[]>[] = []

    let start: number = startIndex
    let end: number = startIndex + PER_FETCH_ALL_COUNT
    for (let i = 1; i <= loopCount; i++) {
      if (this._items !== tempReference) {
        // 状況的に強制終了させるタイミングは、検索結果が更新され新しい検索リストを取得している状況の時なので、新規検索結果が存在しない場合、処理中真偽値フラグは更新しないままとする
        if (this._items.length === 0) {
          this.setIsFetchingBibliographySearchList(false)
        }
        return
      }

      if (end > tempReference.length) {
        end = tempReference.length
      }

      const bibliographies = tempReference
        .slice(start, end)
        .filter(item => item.prefix === Prefix.Real && !item._fetched)
        .map(item => {
          let id
          let marcNo
          if (item.bibliographyId > 0) {
            id = item.bibliographyId
            marcNo = undefined
          } else {
            id = undefined
            marcNo = item.marcNo
          }
          return {
            prefix: item.prefix,
            id,
            marcNo
          }
        })

      if (bibliographies.length > 0) {
        const request: BibliographySearchListDetailRequest = {
          bibliographies,
          displayBranchCode: this._displayOption.displayBranchCode.input
        }

        promiseArray.push(
          bibliographyApi.getBibliographySearchListDetail(request)
        )
      }

      start += PER_FETCH_ALL_COUNT
      end += PER_FETCH_ALL_COUNT
    }

    const results: BibliographySearchListDetail[][] = await Promise.all(
      promiseArray
    )

    results.forEach((result: BibliographySearchListDetail[], index: number) => {
      if (result.length > 0) {
        this.setItemByListDetail({
          startIndex: index * PER_FETCH_ALL_COUNT,
          endIndex: this.items.length - startIndex,
          items: result
        })
      }
    })

    if (this.page === tempPage) {
      this.setIsFetchingBibliographySearchList(false)
    }
  }

  @Action({ rawError: true })
  public async authoritySearch(signal?: AbortSignal) {
    this.setBibliographySearchType('authority')
    let response: BibliographySearchResultAuthorityItem[] = []

    switch (this.authoritySearchType) {
      case AuthoritySearchType.Author:
        response = await bibliographyApi.searchBibliographyAuthorityAuthor(
          {
            searchTarget: this.inputSearchOption.searchTarget.input,
            numberOfLimit: this.inputSearchOption.numberOfLimit.input,
            author: this.inputAuthoritySearchItem.author.input,
            authorNo: this.inputAuthoritySearchItem.author.no
          },
          signal
        )
        break
      case AuthoritySearchType.ContentAuthor:
        response = await bibliographyApi.searchBibliographyAuthorityContentAuthor(
          {
            searchTarget: this.inputSearchOption.searchTarget.input,
            numberOfLimit: this.inputSearchOption.numberOfLimit.input,
            contentAuthor: this.inputAuthoritySearchItem.contentAuthor.input,
            contentAuthorNo: this.inputAuthoritySearchItem.contentAuthor.no
          },
          signal
        )
        break
      case AuthoritySearchType.Subject:
        response = await bibliographyApi.searchBibliographyAuthoritySubject(
          {
            searchTarget: this.inputSearchOption.searchTarget.input,
            numberOfLimit: this.inputSearchOption.numberOfLimit.input,
            subject: this.inputAuthoritySearchItem.subject.input,
            subjectNo: this.inputAuthoritySearchItem.subject.no
          },
          signal
        )
        break
      case AuthoritySearchType.CompleteWorks:
        response = await bibliographyApi.searchBibliographyAuthorityCompleteWorks(
          {
            searchTarget: this.inputSearchOption.searchTarget.input,
            numberOfLimit: this.inputSearchOption.numberOfLimit.input,
            completeWorks: this.inputAuthoritySearchItem.completeWorks.input,
            completeWorksNo: this.inputAuthoritySearchItem.completeWorks.no
          },
          signal
        )
        break
      case AuthoritySearchType.Series:
        response = await bibliographyApi.searchBibliographyAuthoritySeries(
          {
            searchTarget: this.inputSearchOption.searchTarget.input,
            numberOfLimit: this.inputSearchOption.numberOfLimit.input,
            series: this.inputAuthoritySearchItem.series.input,
            seriesNo: this.inputAuthoritySearchItem.series.no
          },
          signal
        )
        break
      case AuthoritySearchType.Publisher:
        response = await bibliographyApi.searchBibliographyAuthorityPublisher(
          {
            searchTarget: this.inputSearchOption.searchTarget.input,
            numberOfLimit: this.inputSearchOption.numberOfLimit.input,
            publisher: this.inputAuthoritySearchItem.publisher.input,
            publisherNo: this.inputAuthoritySearchItem.publisher.no
          },
          signal
        )
        break
    }

    this.setSelectedUids([])
    this.setAuthorityScrollTopValue(0)
    this.setAuthorityActiveRowIndex(-1)

    this.setAuthorityItems(response)
  }

  @Action({ rawError: true })
  public async contentSearch(signal?: AbortSignal) {
    this.setBibliographySearchType('content')
    const response: BibliographySearchResultContentItem[] = await bibliographyApi.searchBibliographyContent(
      {
        displayMethod: this.inputSearchOption.displayMethod.input,
        searchTarget: this.inputSearchOption.searchTarget.input,
        numberOfLimit: this.inputSearchOption.numberOfLimit.input,
        searchMethodAnd: this.inputSearchOption.searchMethodAnd.input,
        searchMethodSynonym: this.inputSearchOption.searchMethodSynonym.input,
        searchMethodAllograph: this.inputSearchOption.searchMethodAllograph
          .input,
        andSearchType: this.inputSearchOption.andSearchType,
        andCollectionTarget: this.inputSearchOption.andCollectionTarget,
        title: this.inputContentSearchItem.title.input,
        contentTitle: this.inputContentSearchItem.contentTitle.input,
        contentTitleNot: this.inputContentSearchItem.contentTitle.not,
        contentAuthor: this.inputContentSearchItem.contentAuthor.input,
        contentAuthorNot: this.inputContentSearchItem.contentAuthor.not,
        contentAuthorNo: this.inputContentSearchItem.contentAuthor.id,
        contentAuthorNos: this.inputContentSearchItem.contentAuthorNos.nos,
        holdingBranchCodes: this.inputContentSearchItem.holdingBranchCodes.input
          .split(',')
          .filter(
            (value, index, array) =>
              value !== '' && array.indexOf(value) === index
          )
      },
      signal
    )

    this.setContentItems(response)
  }

  @Action({ rawError: true })
  public async contentSearchTooli(signal?: AbortSignal) {
    this.setBibliographySearchType('content')
    const result = await bibliographyApi.searchContentTooliBibliographies(
      {
        displayMethod: this.inputSearchOption.displayMethod.input,
        searchMethodAnd: this.inputSearchOption.searchMethodAnd.input,
        title: this.inputContentSearchItem.title.input,
        contentTitle: this.inputContentSearchItem.contentTitle.input,
        contentTitleNot: this.inputContentSearchItem.contentTitle.not,
        contentAuthor: this.inputContentSearchItem.contentAuthor.input,
        contentAuthorNot: this.inputContentSearchItem.contentAuthor.not
      },
      signal
    )

    this.setTotal(result.total)
    this.setItems(result.items)

    this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async authorityIdSearch() {
    this.setSelectedUids([])
    this.setScrollTopValue(0)
    this.setActiveRowIndex(-1)

    const result = await bibliographyApi.getBibliographies(
      BibliographySearchRequestToJSON(this.authorityIdSearchBaseRequest)
    )

    if (this.page === 1) {
      this.setTotal(result.total)
      this.setItems(result.items)
    } else {
      this.addItems(result.items)
    }

    await this.fetchSearchListDetail()
  }

  @Action({ rawError: true })
  public async authorityIdContentSearch(signal?: AbortSignal) {
    const defaultSearchOptionItem: InputSearchOptionItem = defaultInputSearchOptionItem()
    const response: BibliographySearchResultContentItem[] = await bibliographyApi.searchBibliographyContent(
      {
        displayMethod: defaultSearchOptionItem.displayMethod.input,
        searchTarget: defaultSearchOptionItem.searchTarget.input,
        numberOfLimit: defaultSearchOptionItem.numberOfLimit.input,
        searchMethodAnd: defaultSearchOptionItem.searchMethodAnd.input,
        searchMethodSynonym: defaultSearchOptionItem.searchMethodSynonym.input,
        searchMethodAllograph:
          defaultSearchOptionItem.searchMethodAllograph.input,
        andSearchType: defaultSearchOptionItem.andSearchType,
        andCollectionTarget: defaultSearchOptionItem.andCollectionTarget,
        title: '',
        contentTitle: '',
        contentTitleNot: false,
        contentAuthor: '',
        contentAuthorNot: false,
        contentAuthorNo: '',
        contentAuthorNos: this._contentAuthorIds,
        holdingBranchCodes: []
      },
      signal
    )

    this.setContentItems(response)
  }

  @Action({ rawError: true })
  public async basicSearchAll(isReconfigure: boolean = false) {
    const promiseArray: Promise<BibliographySearchResult>[] = []
    const getLength: number = isReconfigure ? this.items.length : this.total
    const numberOfLimit: number = isReconfigure
      ? this.inputSearchOption.numberOfLimit.input
      : SEARCH_ALL_NUMBER_OF_LIMIT

    for (
      let page = 1;
      page <=
      Math.floor(getLength / numberOfLimit) +
        (getLength % numberOfLimit > 0 ? 1 : 0);
      page++
    ) {
      promiseArray.push(
        bibliographyApi.getBibliographies(
          BibliographySearchRequestToJSON({
            ...this.basicSearchBaseRequest,
            numberOfLimit,
            page
          })
        )
      )
    }

    const results: BibliographySearchResult[] = await Promise.all(promiseArray)

    results.forEach((result: BibliographySearchResult, index: number) => {
      if (result.items.length > 0) {
        if (index === 0) {
          this.setItems(result.items)
        } else {
          this.addItems(result.items)
        }
      }
    })
  }

  @Action({ rawError: true })
  public async freeSearchAll(isReconfigure: boolean = false) {
    const promiseArray: Promise<BibliographySearchResult>[] = []

    const getLength = isReconfigure ? this.items.length : this.total
    const numberOfLimit = isReconfigure
      ? this.inputSearchOption.numberOfLimit.input
      : SEARCH_ALL_NUMBER_OF_LIMIT

    for (
      let page = 1;
      page <=
      Math.floor(getLength / numberOfLimit) +
        (getLength % numberOfLimit > 0 ? 1 : 0);
      page++
    ) {
      promiseArray.push(
        bibliographyApi.getFreeBibliographies(
          BibliographyFreeSearchRequestToJSON({
            ...this.freeSearchBaseRequest,
            numberOfLimit,
            page
          })
        )
      )
    }

    const results: BibliographySearchResult[] = await Promise.all(promiseArray)

    results.forEach((result: BibliographySearchResult, index: number) => {
      if (result.items.length > 0) {
        if (index === 0) {
          this.setItems(result.items)
        } else {
          this.addItems(result.items)
        }
      }
    })
  }

  @Action({ rawError: true })
  public async authorityIdSearchAll(isReconfigure: boolean = false) {
    const promiseArray: Promise<BibliographySearchResult>[] = []

    const getLength = isReconfigure ? this.items.length : this.total
    const numberOfLimit = isReconfigure
      ? this.inputSearchOption.numberOfLimit.input
      : SEARCH_ALL_NUMBER_OF_LIMIT

    for (
      let page = 1;
      page <=
      Math.floor(getLength / numberOfLimit) +
        (getLength % numberOfLimit > 0 ? 1 : 0);
      page++
    ) {
      promiseArray.push(
        bibliographyApi.getBibliographies(
          BibliographySearchRequestToJSON({
            ...this.authorityIdSearchBaseRequest,
            numberOfLimit,
            page
          })
        )
      )
    }

    const results: BibliographySearchResult[] = await Promise.all(promiseArray)

    results.forEach((result: BibliographySearchResult, index: number) => {
      if (result.items.length > 0) {
        if (index === 0) {
          this.setItems(result.items)
        } else {
          this.addItems(result.items)
        }
      }
    })

    this.setSelectedUids([])
    this.setScrollTopValue(0)
    this.setActiveRowIndex(-1)
  }

  @Action({ rawError: true })
  public async narrowSearch(obj: {
    narrowKeyword: string
    narrowTarget: NarrowTarget
  }) {
    try {
      this.setNarrowedCondition({
        title: obj.narrowTarget === NarrowTarget.Title ? obj.narrowKeyword : '',
        author:
          obj.narrowTarget === NarrowTarget.Author ? obj.narrowKeyword : '',
        publisher:
          obj.narrowTarget === NarrowTarget.Publisher ? obj.narrowKeyword : '',
        materialFormat:
          obj.narrowTarget === NarrowTarget.MaterialFormat
            ? obj.narrowKeyword
            : '',
        freeWord:
          obj.narrowTarget === NarrowTarget.FreeWord ? obj.narrowKeyword : ''
      })

      await this.reconfigureSearchResult()
    } catch (error) {
      // 現状の処理では絞込の上書きはしない為、失敗した時点で値を初期化
      this.setNarrowedCondition(defaultBibliographySearchNarrowCondition())
      throw error
    }
  }

  @Action({ rawError: true })
  public async reconfigureSearchResult() {
    let result: BibliographySearchResult | undefined

    switch (this.bibliographySearchType) {
      case BibliographySearchType.Basic:
        result = await bibliographyApi.getBibliographies(
          BibliographySearchRequestToJSON({
            ...this.basicSearchBaseRequest,
            _saveHistory: false
          })
        )
        break
      case BibliographySearchType.Alone:
        result = await bibliographyApi.getAloneBibliographies(
          BibliographyAloneSearchRequestToJSON({
            ...this.aloneSearchBaseRequest,
            _saveHistory: false
          })
        )
        break
      case BibliographySearchType.Free:
        result = await bibliographyApi.getFreeBibliographies(
          BibliographyFreeSearchRequestToJSON({
            ...this.freeSearchBaseRequest,
            _saveHistory: false
          })
        )
        break
      case BibliographySearchType.Authority:
        result = await bibliographyApi.getBibliographies(
          BibliographySearchRequestToJSON(this.authorityIdSearchBaseRequest)
        )
        break
    }

    if (result === undefined) {
      return
    }

    this.setTotal(result.total)
    this.setItems(result.items)

    this.fetchSearchListDetail()
  }
}
